import React from "react";
import { Grid } from "@mui/material";
import { ChatRoomList } from "components/chat-room/chat-room-list";
import { Chat } from "components/chat/chat";
import { useParams } from "react-router";
import { jwtPayload } from "utils/helper";

export const ChatRoom: React.FC = () => {
  const routerParams = useParams();
  const chatRoomId = routerParams.chatRoomId ?? "";
  const user = jwtPayload?.email;

  return (
    <>
      <Grid container spacing={2}>
        <Grid
          size={{ sm: 5, md: 3 }}
          display={{ xs: "none", sm: "initial" }}
          sx={{ "&>div": { float: "right" } }}
        >
          <ChatRoomList />
        </Grid>

        <Grid size={{ xs: 12, sm: 7, md: 9 }}>
          <Chat chatRoomId={chatRoomId} user={user} />
        </Grid>
      </Grid>
    </>
  );
};
